import {
  faPhoneSquare,
  faEnvelope,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faLinkedin as faLinkedinBrand,
  faGithub as faGithubBrand,
} from "@fortawesome/free-brands-svg-icons";

export const baseContactData = [
  {
    icon: faPhoneSquare,
    label: "Phone",
    value: "+63 9174211608",
    href: "tel:+639174211608",
  },
  {
    icon: faEnvelope,
    label: "Email",
    value: "donbenaryl@gmail.com",
    href: "mailto:donbenaryl@gmail.com",
  },
];

export const socialContactData = [
  {
    icon: faLinkedinBrand,
    label: "LinkedIn",
    value: "linkedin.com/in/donbenary",
    href: "https://linkedin.com/in/donbenary",
  },
  {
    icon: faGithubBrand,
    label: "GitHub",
    value: "github.com/donbenaryl",
    href: "https://github.com/donbenaryl",
  },
];

/** The optional location row ContactInfo shows between base and social. */
export const buildLocationData = (location?: string) =>
  location
    ? [
        {
          icon: faMapMarkerAlt,
          label: "Location",
          value: location,
          href: undefined as string | undefined,
        },
      ]
    : [];
